<div class="flex transition-transform duration-500 ease-in-out" [style.transform.%]="translateX()">
    <ng-content />
</div>
<div [class]="className() || 'mt-15px'">
    <companyid-prev-next-buttons
        class="w-full"
        [currentItemIndex]="currentIndex()"
        [contentItemsLength]="contentItemsLength()"
        (onChangeSlide)="changeSlide($event)" />
</div>
